import { render, staticRenderFns } from "./ScoreStars.vue?vue&type=template&id=5c8a722f&scoped=true&"
import script from "./ScoreStars.vue?vue&type=script&lang=js&"
export * from "./ScoreStars.vue?vue&type=script&lang=js&"
import style0 from "./ScoreStars.vue?vue&type=style&index=0&id=5c8a722f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8a722f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/induline.salamander.live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c8a722f')) {
      api.createRecord('5c8a722f', component.options)
    } else {
      api.reload('5c8a722f', component.options)
    }
    module.hot.accept("./ScoreStars.vue?vue&type=template&id=5c8a722f&scoped=true&", function () {
      api.rerender('5c8a722f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/ui/ScoreStars.vue"
export default component.exports